import React from 'react';
import PublicStaticLayout from '../components/PublicStaticLayout';

export default function MentionsLegalesPage() {
  return (
    <PublicStaticLayout title="Mentions légales">
      <p>
        Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en
        l&apos;économie numérique, il est précisé aux utilisateurs du site l&apos;identité des
        différents intervenants dans le cadre de sa réalisation et de son suivi.
      </p>

      <h2>Éditeurs de l&apos;application</h2>
      <p>
        L&apos;application <strong>Baromètre Social Temps Réel</strong> est éditée par :
      </p>
      <ul>
        <li>
          <strong>Collectif Webmonster</strong> —{' '}
          <a href="https://www.webmonster.tech" target="_blank" rel="noopener noreferrer">
            webmonster.tech
          </a>
        </li>
        <li>
          <strong>numera11y</strong> —{' '}
          <a href="https://www.numera11y.fr" target="_blank" rel="noopener noreferrer">
            numera11y.fr
          </a>
        </li>
      </ul>
      <p>
        Les éditeurs peuvent être contactés via les moyens indiqués sur leurs sites respectifs.
      </p>

      <h2>Hébergement</h2>
      <p>
        Les données et l&apos;infrastructure d&apos;hébergement dépendent de la configuration
        déployée par l&apos;organisation cliente ou par les éditeurs. Pour toute précision sur
        l&apos;hébergement d&apos;une instance donnée, contactez l&apos;administrateur de votre
        espace ou les éditeurs.
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L&apos;ensemble des éléments composant l&apos;application (textes, visuels, logo,
        architecture, code) sont protégés par le droit de la propriété intellectuelle. Toute
        reproduction ou représentation non autorisée est interdite.
      </p>

      <h2>Responsabilité</h2>
      <p>
        Les éditeurs s&apos;efforcent d&apos;assurer l&apos;exactitude des informations diffusées.
        Ils ne sauraient être tenus responsables des dommages résultant de l&apos;usage de
        l&apos;application ou de l&apos;impossibilité momentanée d&apos;y accéder.
      </p>
    </PublicStaticLayout>
  );
}
